/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { addBeneficiaryAcc, deleteBeneficiaryAcc, sendOtp } from '../../services/depositWithdrawalService';
export default class WithdrawBankDropdownMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isAddAcc: false,
            otpModal: false,
            otp: "",
            addBtnLoader: false,
            previousBankDetailsBtnLdr: false,
            addAccObj: {
                'accountHolderName': '',
                'accountNumber': '',
                'ifscCode': '',
                'upiId': '',
                'network': ''
            },
        };
    }
    componentDidMount() {
        let amount = parseFloat(this.props.amount)
        if (!!this.props.sharing && parseFloat(this.props.sharing) > 0) {
            amount = (parseFloat(this.props.sharing) * amount) / 100
        }
        if (!!this.props.showInverse && this.props.showInverse === true) {
            amount = 0 - amount
        }
        amount = parseFloat(amount).toFixed(2)
        this.setState({ showeble: amount })
    }
    toggleDropDownMenu() {
        this.setState({ isOpen: true });
    }

    onClosePopup() {
        this.setState({ isOpen: false });
    }

    onCloseAccPopup() {
        this.setState({
            isAddAcc: false,
            addBtnLoader: false,
            addAccObj: {
                'accountHolderName': '',
                'accountNumber': '',
                'ifscCode': '',
                'upiId': '',
                'network': ''
            },
        });
    }

    openAddAccountPopup() {
        this.setState({ isAddAcc: true });
    }

    updateAddAccounts(fld, val) {
        this.setState((prevState) => ({
            addAccObj: {
                ...prevState.addAccObj,
                [fld]: val
            }
        }));
    }

    addAccWithOtp(isFirstOtp) {
        let isValid = true;
        if (this.props.activeBeneficiaryType !== "WITHDRAW_CRYPTO" && (!this.state.addAccObj.accountHolderName || this.state.addAccObj.accountHolderName === "")) {
            this.props.notify("Please Insert Account Holder Name!", "error");
            isValid = false;
            return false
        }

        if (this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') {
            if (!this.state.addAccObj.accountNumber || this.state.addAccObj.accountNumber === "") {
                this.props.notify("Please Insert IBAN Number!", "error");
                isValid = false;
                return false
            } 
            // else if(!(/^[A-Z]{4}0[A-Z0-9]{6}$/.test(this.state.addAccObj.ifscCode.toUpperCase()))){
            // // } else if(!(/^[A-Za-z]{4}\d{7}$/.test(this.state.addAccObj.ifscCode))){
            //     this.props.notify("Please Insert Valid IFSC Code!", "error");
            //     isValid = false;
            //     return false
            // }
            if (!this.state.addAccObj.ifscCode || this.state.addAccObj.ifscCode === "") {
                this.props.notify("Please Insert Bank Name!", "error");
                isValid = false;
                return false
            }
        } else if (this.props.activeBeneficiaryType === 'WITHDRAW_BANK') {
            if (!this.state.addAccObj.ifscCode || this.state.addAccObj.ifscCode === "") {
                this.props.notify("Please Insert IFSC Code!", "error");
                isValid = false;
                return false
            } else if(!(/^[A-Z]{4}0[A-Z0-9]{6}$/.test(this.state.addAccObj.ifscCode.toUpperCase()))){
            // } else if(!(/^[A-Za-z]{4}\d{7}$/.test(this.state.addAccObj.ifscCode))){
                this.props.notify("Please Insert Valid IFSC Code!", "error");
                isValid = false;
                return false
            }
            if (!this.state.addAccObj.accountNumber || this.state.addAccObj.accountNumber === "") {
                this.props.notify("Please Insert Account Number!", "error");
                isValid = false;
                return false
            }
        } else if (this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO" && (!this.state.addAccObj.network || this.state.addAccObj.network === "")) {
            this.props.notify("Please Insert Network!", "error");
            isValid = false;
            return false
        } else if (this.props.activeBeneficiaryType === "WITHDRAW_UPI") {
            if (!this.state.addAccObj.upiId || this.state.addAccObj.upiId === "") {
                this.props.notify("Please Insert Upi id!", "error");
                isValid = false;
            }
        } else if (this.props.activeBeneficiaryType === "WITHDRAW_BDTWALLET") {
            if (!this.state.addAccObj.upiId || this.state.addAccObj.upiId === "") {
                this.props.notify("Please Insert Number!", "error");
                isValid = false;
            }
        } else if (this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO") {
            if (!this.state.addAccObj.upiId || this.state.addAccObj.upiId === "") {
                this.props.notify("Please Insert Crypto Address!", "error");
                isValid = false;
            }
        }

        if (isValid) {
            this.setState({addBtnLoader: true},()=>{
                    this.addAccount();
            })
            
            // this.setState({ addBtnLoader: true }, () => {
            //     sendOtp(isFirstOtp).then((res) => {
            //         if (res?.isSuccess) {
            //             this.props.notify(res?.data?.Message, 'success');
            //             this.setState({ otpModal: true, isAddAcc: false, isOpen: false, otp: '', addBtnLoader: false })
            //         } else {
            //             this.props.notify(res?.exception?.message, "error");
            //             this.setState({ isAddAcc: true, addBtnLoader: false })
            //         }
            //     }).catch((err) => {
            //         this.setState({ addBtnLoader: false })
            //     })
            // })  TEMP BYPASS AS PER URGENT REQUIRNMENT HIREN
        }
    }

    onCloseOtpModal() {
        this.setState({ otpModal: false, isAddAcc: true, otp: "" })
    }

    addAccount() {
        const prfdt = JSON.parse(localStorage.getItem('profData'));
        let isValid = true;
        // if (!this.state.otp || this.state.otp === "") {
        //     this.props.notify("Please Enter Otp!", "error");
        //     isValid = false;
        //     return false;
        // }
        if (isValid) {
            let body = {
                "username": prfdt.username,
                "accountHolderName": this.state.addAccObj.accountHolderName,
                "accountNumber": this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? this.state.addAccObj.accountNumber.toUpperCase() : this.props.activeBeneficiaryType === 'WITHDRAW_BANK' ? this.state.addAccObj.accountNumber : this.state.addAccObj.upiId,
                "ifscCode": this.props.activeBeneficiaryType === 'WITHDRAW_BANK' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? this.state.addAccObj.ifscCode.toUpperCase().trim() : '',
                "accountType": this.props.activeBeneficiaryType,
                "network": this.state.addAccObj.network,
                "otp": this.state.otp
            }
            addBeneficiaryAcc(body).then((res) => {
                if (res?.isSuccess) {
                    let addObj = {
                        "beneficiaryId": res?.data?.beneficiaryId?.trim(),
                        "username": prfdt.username?.trim(),
                        "accountHolderName": this.state.addAccObj.accountHolderName?.trim(),
                        "accountNumber": body.accountNumber,//!this.props.withdrawApiBeneficiary.includes(this.props.gatewayProvider) || this.props.gateway === 'Bank' ? this.state.addAccObj.accountNumber?.trim() : this.state.addAccObj.upiId?.trim(),
                        "ifscCode": body.ifscCode, //!this.props.withdrawApiBeneficiary.includes(this.props.gatewayProvider) || this.props.gateway === 'Bank' ? this.state.addAccObj.ifscCode?.trim() : '',
                        "accountType": this.props.activeBeneficiaryType,
                        "network": body.network,
                    }

                    const updatedArray = [...this.props.wholeArray, addObj];
                    this.props.updateArray(updatedArray);
                    this.setState({
                        addBtnLoader: false,
                        otpModal: false,
                        isOpen: true,
                        isAddAcc: false,
                        addAccObj: {
                            'accountHolderName': '',
                            'accountNumber': '',
                            'ifscCode': '',
                            'upiId': '',
                            'network': ''
                        }
                    });
                    this.props.notify(res?.data?.message, "success");
                } else {
                    this.setState({ otpModal: true, addBtnLoader: false });
                    this.props.notify(res?.exception?.message || res?.message, "error");
                }
            })
        }
    }

    deletePreviousBank(itmm) {
        const self = this;
        this.setState({ previousBankDetailsBtnLdr: true }, () => {
            deleteBeneficiaryAcc(itmm.beneficiaryId).then((res) => {
                if (!!res && res.isSuccess) {
                    self.props.notify(res?.data?.message, "success");
                    const updatedArray = this.props.wholeArray?.filter(
                        (ittm) => ittm.beneficiaryId !== itmm.beneficiaryId
                    );
                    this.props.updateArray(updatedArray);

                    self.setState(
                        { previousBankDetailsBtnLdr: false, isOpen: true }
                    );
                } else {
                    self.setState(
                        { previousBankDetailsBtnLdr: false }
                    );
                    self.props.notify(res?.exception?.message, "error");
                }
            });
        })
    }

    itemClick(itmm) {
        if (event.target.tagName === 'I') {
            this.props.MySwal.fire({
                title: 'Are you sure?',
                text: `You want to delete this beneficiary account?`,
                icon: 'warning',
                confirmButtonText: 'OK',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deletePreviousBank(itmm);
                } else {
                    this.setState({ isOpen: true });
                }
            })

        } else {
            this.props.onUsePreviousBankClick(itmm);
            this.setState({ isOpen: false });
        }
    }
    render() {
        let filteredArray = !!this.props.wholeArray && this.props.wholeArray?.length > 0 ? this.props.wholeArray.filter((itm)=> itm.accountType === this.props.activeBeneficiaryType): []
        return (
            <>
                <div className="d-flex justify-content-end mb-3">
                    <button onClick={() => this.toggleDropDownMenu()} className='place-bet-btn'>
                        {/* {this.state.previousBankDetailsBtnLdr &&
                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                            </svg>
                        } */}
                        Benificiary Accounts
                    </button>
                </div>

                {this.state.isOpen && !this.state.isAddAcc &&
                    <div id="savedaccountspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                        <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Beneficiary Account List</h5><button onClick={() => { this.onClosePopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                </div>
                                <div className="modal-body">
                                    <div className="table-responsive">
                                        <table id="basic-btn" className="table  table-bordered font-12 table-sm">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th className="wid150 pthead">{this.props.activeBeneficiaryType === 'WITHDRAW_CRYPTO' ? 'Network' : `${ (this.props.activeBeneficiaryType === 'WITHDRAW_BANK'  || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') ? 'Account' :''}Holder Name`}</th>
                                                    <th className="wid150 pthead">{this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? 'IBAN Number' : this.props.activeBeneficiaryType === 'WITHDRAW_BANK' ? 'Account Number' : (this.props.activeBeneficiaryType === 'WITHDRAW_CRYPTO' ? 'Crypto Address' : (this.props.activeBeneficiaryType === 'WITHDRAW_BDTWALLET' ? 'Number' :'Upi Id'))}</th>
                                                    {this.props.activeBeneficiaryType === 'WITHDRAW_BANK' && <th className="wid150 pthead">IFSC Code</th>}
                                                    {this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' && <th className="wid150 pthead">Bank Name</th>}
                                                    <th className="wid140 pthead">Select</th>
                                                    {/* <th className="wid100 pthead">Delete</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    !!filteredArray && filteredArray?.length > 0 ? filteredArray.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{this.props.activeBeneficiaryType === 'WITHDRAW_CRYPTO' ? item?.network : item?.accountHolderName }</td>
                                                                <td>{item?.accountNumber}</td>
                                                                {(this.props.activeBeneficiaryType === 'WITHDRAW_BANK' || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') && <td>{item?.ifscCode}</td>}
                                                                <td><button className='select-acc-btn' onClick={() => { this.itemClick(item) }}>Select</button></td>
                                                                {/* <td><i className='fa fa-trash text-danger ml-2 cursor' onClick={() => { this.itemClick(item) }}></i></td> */}
                                                            </tr>
                                                        )
                                                    }) :
                                                        <tr>
                                                            <td colSpan={this.props.activeBeneficiaryType === "WITHDRAW_UPI" || this.props.activeBeneficiaryType === "WITHDRAW_BDTWALLET" ? 3 : 4} align="center" className='font-bold'>
                                                                No Beneficiary Account Available. Add New
                                                            </td>
                                                        </tr>
                                                }
                                                <tr colSpan={this.props.activeBeneficiaryType === "WITHDRAW_UPI" || this.props.activeBeneficiaryType === "WITHDRAW_BDTWALLET"  ? 3 : 4}>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="">
                                        <div className="6">

                                            <button type="button" onClick={() => { this.onClosePopup() }} className="btn btn-outline-danger waves-effect mx-auto d-inline" data-dismiss="modal">Cancel</button>
                                            <button disabled={this.props.wholeArray?.length > 16} onClick={() => { this.openAddAccountPopup() }} className="payment-add-btn ml-2 select-acc-btn" data-dismiss="modal" >Add New</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={() => { this.onClosePopup() }}></div>
                    </div>
                }

                {this.state.isAddAcc &&
                    <div id="addnewaccountpopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                        <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add New Beneficiary Account</h5><button onClick={() => { this.onCloseAccPopup() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                </div>
                                <div className="modal-body">
                                    <div className="table-responsive">
                                        <table className='w-100'>
                                            <tbody>
                                                {this.props.activeBeneficiaryType === "WITHDRAW_CRYPTO" ?
                                                        <tr>
                                                            <td className='form-label wid110'>Network:</td>
                                                            <td className='wid280'>
                                                                <input
                                                                    className="form-control mt-2"
                                                                    aria-label="Disabled input example"
                                                                    name="network"
                                                                    type='text'
                                                                    value={this.state.addAccObj.network}
                                                                    onChange={(e) => this.updateAddAccounts('network', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td className='form-label wid110'>{this.props.activeBeneficiaryType === "WITHDRAW_UPI" || this.props.activeBeneficiaryType === "WITHDRAW_BDTWALLET" ? 'Holder' : 'Acc'} Name:</td>
                                                            <td className='wid280'>
                                                                <input
                                                                    className="form-control mt-2"
                                                                    aria-label="Disabled input example"
                                                                    name="accountHolderName"
                                                                    type='text'
                                                                    value={this.state.addAccObj.accountHolderName}
                                                                    onChange={(e) => this.updateAddAccounts('accountHolderName', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                }
                                                {(this.props.activeBeneficiaryType === "WITHDRAW_BANK" || this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK') ?
                                                    <tr>
                                                        <td className='form-label wid110'>{this.props.activeBeneficiaryType === 'WITHDRAW_PKRBANK' ? 'IBAN Number' : 'Account Number'}:</td>
                                                        <td className='wid280'>
                                                            <input
                                                                className="form-control mt-2"
                                                                aria-label="Disabled input example"
                                                                name="accountHolderName"
                                                                type='text'
                                                                value={this.state.addAccObj.accountNumber}
                                                                onChange={(e) => {
                                                                    let allowNumericOnly = e.target.value; //.replace(/\D/g, '')
                                                                    if(this.props.activeBeneficiaryType === "WITHDRAW_BANK"){
                                                                        allowNumericOnly = allowNumericOnly.replace(/\D/g, '')
                                                                    }
                                                                    this.updateAddAccounts('accountNumber', allowNumericOnly)
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                    :
                                                    
                                                    <tr>
                                                    <td className='form-label wid110'>{this.props.activeBeneficiaryType === "WITHDRAW_UPI" ? "Upi Id" : ( "WITHDRAW_BDTWALLET" ? "Number" : "Crypto Address")}:</td>
                                                    <td className='wid280'>
                                                        <input
                                                            className="form-control mt-2"
                                                            aria-label="Disabled input example"
                                                            name="accountHolderName"
                                                            type='text'
                                                            value={this.state.addAccObj.upiId}
                                                            onChange={(e) => this.updateAddAccounts('upiId', e.target.value)}
                                                        />
                                                    </td>
                                                </tr>
                                                }
                                                {this.props.activeBeneficiaryType === "WITHDRAW_BANK"  &&
                                                        <tr>
                                                            <td className='form-label wid110'>IFSC Code:</td>
                                                            <td className='wid280'>
                                                                <input
                                                                    className="form-control mt-2 text-transform-uppercase"
                                                                    aria-label="Disabled input example"
                                                                    name="accountHolderName"
                                                                    type='text'
                                                                    value={this.state.addAccObj.ifscCode}
                                                                    onChange={(e) => this.updateAddAccounts('ifscCode', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                }
                                                {this.props.activeBeneficiaryType === "WITHDRAW_PKRBANK"  &&
                                                        <tr>
                                                            <td className='form-label wid110'>Bank Name:</td>
                                                            <td className='wid280'>
                                                                <input
                                                                    className="form-control mt-2 text-transform-uppercase"
                                                                    aria-label="Disabled input example"
                                                                    name="accountHolderName"
                                                                    type='text'
                                                                    value={this.state.addAccObj.ifscCode}
                                                                    onChange={(e) => this.updateAddAccounts('ifscCode', e.target.value)}
                                                                />
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <div className="">
                                        <div className="">

                                            <button type="button" onClick={() => { this.onCloseAccPopup() }} className="btn btn-outline-danger waves-effect mx-auto d-inline" data-dismiss="modal">Cancel</button>
                                            <button type="button" disabled={this.state.addBtnLoader} onClick={() => { this.addAccWithOtp(false) }} className="payment-add-btn select-acc-btn ml-2" data-dismiss="modal">Add</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={() => { this.onClosePopup() }}></div>
                    </div>
                }

                {/* {this.state.otpModal &&
                    <div id="submitotppopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                        <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">OTP</h5><button onClick={() => { this.onCloseOtpModal() }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                </div>
                                <div className="modal-body">
                                    <div className="table-responsive">
                                        <tr className=''>
                                            <td className='form-label margin-right2'>OTP:</td>
                                            <td className=''>
                                                <input
                                                    className="form-control mt-2 ml-2"
                                                    aria-label="Disabled input example"
                                                    name="accountHolderName"
                                                    type='text'
                                                    value={this.state.otp}
                                                    maxLength={6}
                                                    minLength={6}
                                                    onChange={(e) => {
                                                        const allowNumericOnly = e.target.value.replace(/\D/g, '')
                                                        this.setState({ otp: allowNumericOnly })
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <button type="button" onClick={() => { this.addAccWithOtp(true); this.setState({ otp: "" }) }} disabled={this.state.addBtnLoader} className="btn btn-danger waves-effect mx-auto d-inline resendotpbtn" data-dismiss="modal" >Resend OTP</button>
                                            </td>
                                        </tr>
                                    </div>
                                </div>
                                <div className="modal-footer bt1-footer">
                                    <div className="">
                                        <div className="">
                                            <button type="button" onClick={() => { this.onCloseOtpModal() }} className="btn btn-outline-danger waves-effect mx-auto d-inline" data-dismiss="modal">Cancel</button>
                                            <button type="button" disabled={this.state.otp?.length < 6} onClick={() => { this.addAccount() }} className="payment-add-btn select-acc-btn ml-2" data-dismiss="modal">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={() => { this.onClosePopup() }}></div>
                    </div>
                } */}
            </>
        )
    }
}
